import SubscriptionInfo from './SubscriptionInfo.vue';

export default SubscriptionInfo;
